import { FormProvider } from 'react-hook-form';
import { useEditInternalNews } from './hooks';
import { EditInternalNewsPresentation } from './presentations';

type Props = {
  newsId: number;
};

export const EditInternalNews: React.FC<Props> = ({ newsId }) => {
  const {
    state: {
      methods,
      initialValues,
      isMutating,
      publishMode,
      existingAttachments,
      files,
      isFileUploading,
      isFileUploadDisabled,
      mainImageUrl,
    },
    actions: {
      handleSubmit,
      handleRemoveExistingAttachment,
      handleRemoveMainImage,
      handleFilesChange,
    },
  } = useEditInternalNews({ newsId });

  return (
    <FormProvider {...methods}>
      <EditInternalNewsPresentation
        existingAttachments={existingAttachments}
        title={initialValues.title}
        isPublished={initialValues.isPublished}
        publishMode={publishMode}
        isMutating={isMutating}
        onSubmit={handleSubmit}
        onRemoveExistingAttachment={handleRemoveExistingAttachment}
        onRemoveMainImage={handleRemoveMainImage}
        mainImageUrl={mainImageUrl}
        attachedFiles={files}
        isFileUploading={isFileUploading}
        isFileUploadDisabled={isFileUploadDisabled}
        onFilesChange={handleFilesChange}
      />
    </FormProvider>
  );
};
